<template>
	<div>
		<navigation msg="设备管理/基本信息" />
		<router-view />
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default {
		data() {
			return {
	
			}
		},
		components: {
			navigation
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/macFaultType/home.vue